import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { HeaderComponent } from "./components/header/header.component";
import { HeaderInnerComponent } from "./components/header-inner/header-inner.component";
import { ScrollTopComponent } from "./components/scroll-top/scroll-top.component";
import { ServiceComponent } from "./components/service/service.component";
import { ServicesComponent } from "./components/services/services.component";
import { TestimonialComponent } from "./components/testimonial/testimonial.component";
import { VTwoContactMapComponent } from "./components/v-two-contact-map/v-two-contact-map.component";
import { VTwoFooterStyle2Component } from "./components/v-two-footer-style2/v-two-footer-style2.component";
import { VTwoSectionTitleComponent } from "./components/v-two-section-title/v-two-section-title.component";
import { FlyIconComponent } from './components/fly-icon/fly-icon.component';

const components = [VTwoContactMapComponent,FlyIconComponent, VTwoSectionTitleComponent, VTwoFooterStyle2Component, ScrollTopComponent, HeaderComponent, HeaderInnerComponent, TestimonialComponent, ServiceComponent, ServicesComponent]
@NgModule({
    declarations: [...components],
    imports: [
        CommonModule,
        RouterModule
    ],
    exports: [...components]
})
export class SharedModule { }
